import type { IconSvgObject } from './types';

const DirectionRight02Icon: IconSvgObject = [
  ["path", { d: "M10 11V21M10 3V4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M6.5 21H13.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M15.7991 4.41876C15.6114 4.15597 15.3083 4 14.9854 4L7 4C6.44772 4 6 4.44772 6 5V10C6 10.5523 6.44772 11 7 11H14.9854C15.3083 11 15.6114 10.844 15.7991 10.5812L18 7.5L15.7991 4.41876Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default DirectionRight02Icon;
